/**
 * A tenant asking to settle what they owe.
 */
export default class PayBalanceRequestDto {

    /**
     * A card the processor already holds. Ignored when newCard is set.
     * @type{string|null}
     */
    paymentProfileId = null;

    /**
     * A card being entered now, which is stored before it is charged.
     * @type{CardPaymentDto|null}
     */
    newCard = null;

    /**
     * Whether to point the tenant's active subscriptions at the card used here.
     * @type{boolean}
     */
    saveAsDefault = false;

    /**
     * What this screen believed was owed when it was drawn.
     *
     * The server refuses the payment if its own figure differs, so a page left open across a
     * billing run cannot charge an amount the tenant never agreed to.
     * @type{number}
     */
    expectedAmount = 0;
}
